import { CardType } from "store/paymentMethods/paymentMethods-state";

export const getCardType = (rawCardNumber: string): CardType => {
  const cardNumber = rawCardNumber.replace(/\D/g, "");
  const length = cardNumber.length;

  const prefix2 = parseInt(cardNumber.slice(0, 2), 10);
  const prefix3 = parseInt(cardNumber.slice(0, 3), 10);
  const prefix4 = parseInt(cardNumber.slice(0, 4), 10);
  const prefix6 = parseInt(cardNumber.slice(0, 6), 10);

  const isMasterCardPrefix =
    (prefix2 >= 51 && prefix2 <= 55) || (prefix4 >= 2221 && prefix4 <= 2720);
  const isDiscoverPrefix =
    cardNumber.startsWith("6011") ||
    cardNumber.startsWith("65") ||
    (prefix3 >= 644 && prefix3 <= 649) ||
    (prefix6 >= 622126 && prefix6 <= 622925);
  const isJcbPrefix =
    (prefix4 >= 3528 && prefix4 <= 3589) ||
    cardNumber.startsWith("2131") ||
    cardNumber.startsWith("1800");

  // Authorize.net treats some 30xx test cards (e.g. 3088...) as JCB-family.
  const isDinersOrJcbFamily = /^(30|36|38|39)/.test(cardNumber);

  if (/^3[47]/.test(cardNumber) && length === 15) {
    return CardType.AMEX;
  } else if (/^4/.test(cardNumber) && (length === 13 || length === 16 || length === 19)) {
    return CardType.VISA;
  } else if (isMasterCardPrefix && length === 16) {
    return CardType.MASTER_CARD;
  } else if (isDiscoverPrefix && (length === 16 || length === 19)) {
    return CardType.DISCOVER;
  } else if (
    (isJcbPrefix &&
      (length === 15 ||
        length === 16 ||
        length === 17 ||
        length === 18 ||
        length === 19)) ||
    (isDinersOrJcbFamily && (length === 14 || length === 16))
  ) {
    return CardType.JCB;
  } else {
    return CardType.EWALLET;
  }
};
